<template>
  <Configuration :items="items" :width="1089" :height="442">
    <template v-slot:base>
      <svg
        class="base"
        fill="none"
        width="1440"
        height="900"
        viewBox="0 0 1440 900"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1440 0H0V900H1440V0Z" fill="#F7FAFC" />
        <path
          d="M1285.57 126.04H154.43V155.22H1285.57V126.04Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M492.3 501.23H525.59C527.247 501.23 528.59 499.887 528.59 498.23V464.94C528.59 463.283 527.247 461.94 525.59 461.94H492.3C490.643 461.94 489.3 463.283 489.3 464.94V498.23C489.3 499.887 490.643 501.23 492.3 501.23Z"
          fill="#BCBEC0"
        />
        <path
          d="M492.51 325.97H525.8C527.457 325.97 528.8 324.627 528.8 322.97V289.68C528.8 288.023 527.457 286.68 525.8 286.68H492.51C490.853 286.68 489.51 288.023 489.51 289.68V322.97C489.51 324.627 490.853 325.97 492.51 325.97Z"
          fill="#BCBEC0"
        />
        <path
          d="M1285.57 748.57H154.43V777.75H1285.57V748.57Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M154.43 811.37H1285.57"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M828.64 772.41H817.72V783.33H828.64V772.41Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M823.18 783.33V811.37"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M570.44 772.41H559.52V783.33H570.44V772.41Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M564.98 783.33V811.37"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1086.84 772.41H1075.92V783.33H1086.84V772.41Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1081.38 783.33V811.37"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M312.24 772.41H301.32V783.33H312.24V772.41Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M306.78 783.33V811.37"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1285.57 78.48H154.43V107.66H1285.57V78.48Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1234.32 832.1H1288.68V34.32H1234.32V832.1Z"
          fill="url(#paint0_linear_868_432)"
        />
        <path
          d="M1288.68 83.76V29.4L152.36 29.4V83.76L1288.68 83.76Z"
          fill="url(#paint1_linear_868_432)"
        />
        <path
          d="M325.21 107.66V522.55H443.64V480.43H433.27V470.71H443.64C449.01 470.71 453.36 475.06 453.36 480.43V522.55C453.36 527.92 449.01 532.27 443.64 532.27H322.49C318.62 532.27 315.49 529.14 315.49 525.27V107.66H325.21V107.66Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M384.71 480.43H354.17C350.3 480.43 347.17 477.3 347.17 473.43V155.22H356.89V470.71H384.7V480.43H384.71Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M206.72 34.3199H152.36V832.1H206.72V34.3199Z"
          fill="url(#paint2_linear_868_432)"
        />
        <path
          d="M408.98 420.99V446.67"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <g filter="url(#filter0_d_868_432)">
          <path
            d="M390.12 470.39H384.7V480.57H390.12V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M390.12 477.46H384.7"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M384.7 473.5H390.12"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M394.54 472.18H390.12V478.78H394.54V472.18Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M427.83 472.18H423.41V478.78H427.83V472.18Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M401.95 470.39H394.54V480.57H401.95V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M423.41 470.39H416V480.57H423.41V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M416 470.39H401.95V490.34H416V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M416 464.14H401.95V470.39H416V464.14Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M414.15 457.88H403.81V464.13H414.15V457.88Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M412.04 453.17H405.92V457.88H412.04V453.17Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M414.42 446.67H403.53V453.17H414.42V446.67Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M406.41 453.17V446.67"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M411.54 446.67V453.17"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M414.15 490.34H403.81V493.5H414.15V490.34Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M412.04 493.5H405.92V495.95H412.04V493.5Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M433.28 470.39H427.86V480.57H433.28V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M433.28 477.46H427.86"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M427.86 473.5H433.28"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M408.98 372.16C408.98 335.8 438.45 306.33 474.81 306.33H509.15"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <g filter="url(#filter1_d_868_432)">
          <path
            d="M413.85 416.34H404.1V420.99H413.85V416.34Z"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M440.73 380.1H422.25V397.66H440.73V380.1Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M437.62 380.1V397.66"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M422.24 382.17H417.46V395.59H422.24V382.17Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M402.01 372.16V380.44L395.01 372.95L386.14 381.82L402.01 399.16H417.46V372.16H402.01Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M415.69 399.16H402.01V405.26H415.69V399.16Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M413.85 411.69H404.1V416.34H413.85V411.69Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M412.18 405.27H405.76V411.69H412.18V405.27Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M417.46 397.75L413.58 394.64V377.53L417.46 374.42V397.75Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M403.67 389.82H413.59V392.81H403.67C402.85 392.81 402.18 392.14 402.18 391.32C402.18 390.5 402.85 389.83 403.67 389.83V389.82Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M411.14 372.16H405.25V381.72H411.14V372.16Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M347.17 466.57H356.89"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M361.04 470.71V480.43"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M315.49 518.4H325.21"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M329.36 522.54V532.27"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M439.5 532.27V522.54"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M443.65 518.4H453.37"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M453.37 484.51H443.65"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M439.5 480.37V470.65"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M721.91 501.23H755.2C756.857 501.23 758.2 499.887 758.2 498.23V464.94C758.2 463.283 756.857 461.94 755.2 461.94H721.91C720.253 461.94 718.91 463.283 718.91 464.94V498.23C718.91 499.887 720.253 501.23 721.91 501.23Z"
          fill="#BCBEC0"
        />
        <path
          d="M722.12 325.97H755.41C757.067 325.97 758.41 324.627 758.41 322.97V289.68C758.41 288.023 757.067 286.68 755.41 286.68H722.12C720.463 286.68 719.12 288.023 719.12 289.68V322.97C719.12 324.627 720.463 325.97 722.12 325.97Z"
          fill="#BCBEC0"
        />
        <path
          d="M554.82 107.66V522.55H673.25V480.43H662.88V470.71H673.25C678.62 470.71 682.97 475.06 682.97 480.43V522.55C682.97 527.92 678.62 532.27 673.25 532.27H552.1C548.23 532.27 545.1 529.14 545.1 525.27V107.66H554.82Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M614.32 480.43H583.78C579.91 480.43 576.78 477.3 576.78 473.43V155.22H586.5V470.71H614.31V480.43H614.32Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M638.59 420.99V446.67"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <g filter="url(#filter2_d_868_432)">
          <path
            d="M619.73 470.39H614.31V480.57H619.73V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M619.73 477.46H614.31"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M614.31 473.5H619.73"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M624.15 472.18H619.73V478.78H624.15V472.18Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M657.44 472.18H653.02V478.78H657.44V472.18Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M631.56 470.39H624.15V480.57H631.56V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M653.02 470.39H645.61V480.57H653.02V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M645.61 470.39H631.56V490.34H645.61V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M645.61 464.14H631.56V470.39H645.61V464.14Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M643.76 457.88H633.42V464.13H643.76V457.88Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M641.65 453.17H635.53V457.88H641.65V453.17Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M644.03 446.67H633.14V453.17H644.03V446.67Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M636.02 453.17V446.67"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M641.15 446.67V453.17"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M643.76 490.34H633.42V493.5H643.76V490.34Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M641.65 493.5H635.53V495.95H641.65V493.5Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M662.89 470.39H657.47V480.57H662.89V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M662.89 477.46H657.47"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M657.47 473.5H662.89"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M638.59 372.16C638.59 335.8 668.06 306.33 704.42 306.33H738.76"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <g filter="url(#filter3_d_868_432)">
          <path
            d="M643.46 416.34H633.71V420.99H643.46V416.34Z"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M670.34 380.1H651.86V397.66H670.34V380.1Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M667.23 380.1V397.66"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M651.85 382.17H647.07V395.59H651.85V382.17Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M631.62 372.16V380.44L624.62 372.95L615.75 381.82L631.62 399.16H647.07V372.16H631.62Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M645.3 399.16H631.62V405.26H645.3V399.16Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M643.46 411.69H633.71V416.34H643.46V411.69Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M641.79 405.27H635.37V411.69H641.79V405.27Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M647.07 397.75L643.19 394.64V377.53L647.07 374.42V397.75Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M633.28 389.82H643.2V392.81H633.28C632.46 392.81 631.79 392.14 631.79 391.32C631.79 390.5 632.46 389.83 633.28 389.83V389.82Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M640.75 372.16H634.86V381.72H640.75V372.16Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M576.78 466.57H586.5"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M590.65 470.71V480.43"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M545.1 518.4H554.82"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M558.97 522.54V532.27"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M669.11 532.27V522.54"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M673.26 518.4H682.98"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M682.98 484.51H673.26"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M669.11 480.37V470.65"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M951.52 501.23H984.81C986.467 501.23 987.81 499.887 987.81 498.23V464.94C987.81 463.283 986.467 461.94 984.81 461.94H951.52C949.863 461.94 948.52 463.283 948.52 464.94V498.23C948.52 499.887 949.863 501.23 951.52 501.23Z"
          fill="#BCBEC0"
        />
        <path
          d="M951.73 325.97H985.02C986.677 325.97 988.02 324.627 988.02 322.97V289.68C988.02 288.023 986.677 286.68 985.02 286.68H951.73C950.073 286.68 948.73 288.023 948.73 289.68V322.97C948.73 324.627 950.073 325.97 951.73 325.97Z"
          fill="#BCBEC0"
        />
        <path
          d="M784.43 107.66V522.55H902.86V480.43H892.49V470.71H902.86C908.23 470.71 912.58 475.06 912.58 480.43V522.55C912.58 527.92 908.23 532.27 902.86 532.27H781.71C777.84 532.27 774.71 529.14 774.71 525.27V107.66H784.43Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M843.93 480.43H813.39C809.52 480.43 806.39 477.3 806.39 473.43V155.22H816.11V470.71H843.92V480.43H843.93Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M868.2 420.99V446.67"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <g filter="url(#filter4_d_868_432)">
          <path
            d="M849.34 470.39H843.92V480.57H849.34V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M849.34 477.46H843.92"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M843.92 473.5H849.34"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M853.76 472.18H849.34V478.78H853.76V472.18Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M887.05 472.18H882.63V478.78H887.05V472.18Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M861.17 470.39H853.76V480.57H861.17V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M882.63 470.39H875.22V480.57H882.63V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M875.22 470.39H861.17V490.34H875.22V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M875.22 464.14H861.17V470.39H875.22V464.14Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M873.37 457.88H863.03V464.13H873.37V457.88Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M871.26 453.17H865.14V457.88H871.26V453.17Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M873.64 446.67H862.75V453.17H873.64V446.67Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M865.63 453.17V446.67"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M870.76 446.67V453.17"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M873.37 490.34H863.03V493.5H873.37V490.34Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M871.26 493.5H865.14V495.95H871.26V493.5Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M892.5 470.39H887.08V480.57H892.5V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M892.5 477.46H887.08"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M887.08 473.5H892.5"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M868.2 372.16C868.2 335.8 897.67 306.33 934.03 306.33H968.37"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <g filter="url(#filter5_d_868_432)">
          <path
            d="M873.07 416.34H863.32V420.99H873.07V416.34Z"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M899.95 380.1H881.47V397.66H899.95V380.1Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M896.84 380.1V397.66"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M881.46 382.17H876.68V395.59H881.46V382.17Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M861.23 372.16V380.44L854.23 372.95L845.36 381.82L861.23 399.16H876.68V372.16H861.23Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M874.91 399.16H861.23V405.26H874.91V399.16Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M873.07 411.69H863.32V416.34H873.07V411.69Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M871.4 405.27H864.98V411.69H871.4V405.27Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M876.68 397.75L872.8 394.64V377.53L876.68 374.42V397.75Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M862.89 389.82H872.81V392.81H862.89C862.07 392.81 861.4 392.14 861.4 391.32C861.4 390.5 862.07 389.83 862.89 389.83V389.82Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M870.36 372.16H864.47V381.72H870.36V372.16Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M806.39 466.57H816.11"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M820.26 470.71V480.43"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M774.71 518.4H784.43"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M788.58 522.54V532.27"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M898.72 532.27V522.54"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M902.87 518.4H912.59"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M912.59 484.51H902.87"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M898.72 480.37V470.65"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1181.13 501.23H1214.42C1216.08 501.23 1217.42 499.887 1217.42 498.23V464.94C1217.42 463.283 1216.08 461.94 1214.42 461.94H1181.13C1179.47 461.94 1178.13 463.283 1178.13 464.94V498.23C1178.13 499.887 1179.47 501.23 1181.13 501.23Z"
          fill="#BCBEC0"
        />
        <path
          d="M1181.33 325.97H1214.62C1216.28 325.97 1217.62 324.627 1217.62 322.97V289.68C1217.62 288.023 1216.28 286.68 1214.62 286.68H1181.33C1179.67 286.68 1178.33 288.023 1178.33 289.68V322.97C1178.33 324.627 1179.67 325.97 1181.33 325.97Z"
          fill="#BCBEC0"
        />
        <path
          d="M1014.04 107.66V522.55H1132.47V480.43H1122.1V470.71H1132.47C1137.84 470.71 1142.19 475.06 1142.19 480.43V522.55C1142.19 527.92 1137.84 532.27 1132.47 532.27H1011.32C1007.45 532.27 1004.32 529.14 1004.32 525.27V107.66H1014.04V107.66Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1073.54 480.43H1043C1039.13 480.43 1036 477.3 1036 473.43V155.22H1045.72V470.71H1073.53V480.43H1073.54Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1097.81 420.99V446.67"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <g filter="url(#filter6_d_868_432)">
          <path
            d="M1078.95 470.39H1073.53V480.57H1078.95V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1078.95 477.46H1073.53"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1073.53 473.5H1078.95"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1083.37 472.18H1078.95V478.78H1083.37V472.18Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1116.66 472.18H1112.24V478.78H1116.66V472.18Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1090.78 470.39H1083.37V480.57H1090.78V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1112.24 470.39H1104.83V480.57H1112.24V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1104.83 470.39H1090.78V490.34H1104.83V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1104.83 464.14H1090.78V470.39H1104.83V464.14Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1102.98 457.88H1092.64V464.13H1102.98V457.88Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1100.87 453.17H1094.75V457.88H1100.87V453.17Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1103.25 446.67H1092.36V453.17H1103.25V446.67Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1095.24 453.17V446.67"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1100.37 446.67V453.17"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1102.98 490.34H1092.64V493.5H1102.98V490.34Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1100.87 493.5H1094.75V495.95H1100.87V493.5Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1122.11 470.39H1116.69V480.57H1122.11V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1122.11 477.46H1116.69"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1116.69 473.5H1122.11"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M1097.81 372.16C1097.81 335.8 1127.28 306.33 1163.64 306.33H1197.98"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <g filter="url(#filter7_d_868_432)">
          <path
            d="M1102.68 416.34H1092.93V420.99H1102.68V416.34Z"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1129.56 380.1H1111.08V397.66H1129.56V380.1Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1126.45 380.1V397.66"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1111.07 382.17H1106.29V395.59H1111.07V382.17Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1090.84 372.16V380.44L1083.84 372.95L1074.97 381.82L1090.84 399.16H1106.29V372.16H1090.84Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1104.52 399.16H1090.84V405.26H1104.52V399.16Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1102.68 411.69H1092.93V416.34H1102.68V411.69Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1101.01 405.27H1094.59V411.69H1101.01V405.27Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1106.29 397.75L1102.41 394.64V377.53L1106.29 374.42V397.75Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1092.5 389.82H1102.42V392.81H1092.5C1091.68 392.81 1091.01 392.14 1091.01 391.32C1091.01 390.5 1091.68 389.83 1092.5 389.83V389.82Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1099.97 372.16H1094.08V381.72H1099.97V372.16Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M1036 466.57H1045.72"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1049.87 470.71V480.43"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1004.32 518.4H1014.04"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1018.19 522.54V532.27"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1128.33 532.27V522.54"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1132.48 518.4H1142.2"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1142.2 484.51H1132.48"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1128.33 480.37V470.65"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M235.28 368.63H223.95V381.5H235.28V368.63Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M229.61 377C230.753 377 231.68 376.073 231.68 374.93C231.68 373.787 230.753 372.86 229.61 372.86C228.467 372.86 227.54 373.787 227.54 374.93C227.54 376.073 228.467 377 229.61 377Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M289.94 368.63H278.61V381.5H289.94V368.63Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M284.28 377C285.423 377 286.35 376.073 286.35 374.93C286.35 373.787 285.423 372.86 284.28 372.86C283.137 372.86 282.21 373.787 282.21 374.93C282.21 376.073 283.137 377 284.28 377Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M235.28 484.3H223.95V497.17H235.28V484.3Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M229.61 492.94C230.753 492.94 231.68 492.013 231.68 490.87C231.68 489.727 230.753 488.8 229.61 488.8C228.467 488.8 227.54 489.727 227.54 490.87C227.54 492.013 228.467 492.94 229.61 492.94Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M289.94 484.3H278.61V497.17H289.94V484.3Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M284.55 492.94C285.693 492.94 286.62 492.013 286.62 490.87C286.62 489.727 285.693 488.8 284.55 488.8C283.407 488.8 282.48 489.727 282.48 490.87C282.48 492.013 283.407 492.94 284.55 492.94Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g filter="url(#filter8_d_868_432)">
          <path
            d="M292.86 381.5H221.04C218.781 381.5 216.95 383.331 216.95 385.59V480.21C216.95 482.469 218.781 484.3 221.04 484.3H292.86C295.119 484.3 296.95 482.469 296.95 480.21V385.59C296.95 383.331 295.119 381.5 292.86 381.5Z"
            fill="#F7FAFC"
          />
          <path
            d="M292.86 381.5H221.04C218.781 381.5 216.95 383.331 216.95 385.59V480.21C216.95 482.469 218.781 484.3 221.04 484.3H292.86C295.119 484.3 296.95 482.469 296.95 480.21V385.59C296.95 383.331 295.119 381.5 292.86 381.5Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M293.95 385.58V480.21C293.95 480.81 293.46 481.3 292.86 481.3H221.03C220.43 481.3 219.94 480.81 219.94 480.21V385.59C219.94 384.99 220.43 384.5 221.03 384.5H292.86C293.46 384.5 293.95 384.99 293.95 385.59V385.58Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M288.76 387.96H225.14V477.85H288.76V387.96Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M237.32 431.1H228.05V439.31H237.32V431.1Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M228.93 435.21V436.16H229.79V437.25H230.72V438.35H234.51V437.19H236.44V435.21V433.23H234.51V432.07H230.72V433.17H229.79V434.26H228.93V435.21Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M237.32 441.55H228.05V449.76H237.32V441.55Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M228.93 445.65V446.6H229.79V447.7H230.72V448.79H234.51V447.63H236.44V445.65V443.67H234.51V442.51H230.72V443.61H229.79V444.71H228.93V445.65Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M237.32 451.99H228.05V460.2H237.32V451.99Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M228.93 456.1V457.04H229.79V458.14H230.72V459.24H234.51V458.08H236.44V456.1V454.11H234.51V452.95H230.72V454.05H229.79V455.15H228.93V456.1Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M237.32 462.43H228.05V470.64H237.32V462.43Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M228.93 466.54V467.48H229.79V468.58H230.72V469.68H234.51V468.52H236.44V466.54V464.56H234.51V463.4H230.72V464.49H229.79V465.59H228.93V466.54Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M276.57 439.32H285.84V431.11H276.57V439.32Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M284.96 435.21V436.16H284.11V437.25H283.18V438.35H279.39V437.19H277.45V435.21V433.23H279.39V432.07H283.18V433.17H284.11V434.26H284.96V435.21Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M276.57 449.76H285.84V441.55H276.57V449.76Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M284.96 445.65V446.6H284.11V447.7H283.18V448.79H279.39V447.63H277.45V445.65V443.67H279.39V442.51H283.18V443.61H284.11V444.71H284.96V445.65Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M276.57 460.2H285.84V451.99H276.57V460.2Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M284.96 456.1V457.04H284.11V458.14H283.18V459.24H279.39V458.08H277.45V456.1V454.11H279.39V452.95H283.18V454.05H284.11V455.15H284.96V456.1Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M276.57 470.65H285.84V462.44H276.57V470.65Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M284.96 466.54V467.48H284.11V468.58H283.18V469.68H279.39V468.52H277.45V466.54V464.56H279.39V463.4H283.18V464.49H284.11V465.59H284.96V466.54Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M244.31 433.49H239.43V435.64H244.31V433.49Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M244.31 437.63H239.43V439.78H244.31V437.63Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M244.31 441.78H239.43V443.93H244.31V441.78Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M244.31 445.93H239.43V448.08H244.31V445.93Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M242.24 452.02H239.43V460.39H242.24V452.02Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M247.72 420.69H244.91V424.87H247.72V420.69Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M261.57 406.74H261.56C260.787 406.74 260.16 407.367 260.16 408.14V413.71C260.16 414.483 260.787 415.11 261.56 415.11H261.57C262.343 415.11 262.97 414.483 262.97 413.71V408.14C262.97 407.367 262.343 406.74 261.57 406.74Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M243.28 462.32H239.43V464.47H243.28V462.32Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M249.5 462.32H245.65V464.47H249.5V462.32Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M243.28 466.47H239.43V468.62H243.28V466.47Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M249.5 466.47H245.65V468.62H249.5V466.47Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M250.91 411.83V400.47H239.55V411.83H250.91Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M249.15 402.23H241.32V410.06H249.15V402.23Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M268.31 434.76H263.41V442.48H268.31V434.76Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M254.51 444.09H251.03V456.08H254.51V444.09Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M260.39 444.09H256.91V456.08H260.39V444.09Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M260.57 458.19H257V468.52H260.57V458.19Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M228.03 403.42V406.99H236.99V403.42H228.03Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M265.03 459.23H263.54V469.56H265.03V459.23Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M268.14 459.23H266.65V469.56H268.14V459.23Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M271.25 459.23H269.76V469.56H271.25V459.23Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M274.36 459.23H272.87V469.56H274.36V459.23Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M267.22 432.8V431.25H264.51V432.8H267.22Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M274.66 434.76H269.76V442.48H274.66V434.76Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M273.62 421H269.76V424.86H273.62V421Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M283.14 421H279.28V424.86H283.14V421Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M273.57 432.81V431.26H270.86V432.81H273.57Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M268.31 448.24H263.41V455.96H268.31V448.24Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M267.22 446.28V444.73H264.51V446.28H267.22Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M274.66 448.24H269.76V455.96H274.66V448.24Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M273.57 446.29V444.74H270.86V446.29H273.57Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M260.64 439.86H259.09V442.57H260.64V439.86Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M249.05 443.37H247.5V447.12H249.05V443.37Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M257.61 415.11V413.56H254.9V415.11H257.61Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M252.38 398.28H263.25"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M252.38 399.56H263.25"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M252.38 400.83H263.25"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M252.38 402.1H263.25"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M252.38 403.38H263.25"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M252.38 397.01H263.25"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M259.73 394.76V405.63"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M258.45 394.76V405.63"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M257.18 394.76V405.63"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M255.91 394.76V405.63"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M254.63 394.76V405.63"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M261 394.76V405.63"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M262.17 395.87H253.46V404.51H262.17V395.87Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M276.21 395.87H266.47V404.51H276.21V395.87Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M246.32 419.34C247.971 419.34 249.31 418.001 249.31 416.35C249.31 414.699 247.971 413.36 246.32 413.36C244.669 413.36 243.33 414.699 243.33 416.35C243.33 418.001 244.669 419.34 246.32 419.34Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M231.84 412.32C233.491 412.32 234.83 411.653 234.83 410.83C234.83 410.007 233.491 409.34 231.84 409.34C230.189 409.34 228.85 410.007 228.85 410.83C228.85 411.653 230.189 412.32 231.84 412.32Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M252.47 424.77C253.597 424.77 254.51 423.857 254.51 422.73C254.51 421.603 253.597 420.69 252.47 420.69C251.343 420.69 250.43 421.603 250.43 422.73C250.43 423.857 251.343 424.77 252.47 424.77Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M236.69 397.95V394.3H228.03V397.95H236.69Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M236.69 401.6V397.95H228.03V401.6H236.69Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M231.85 397.95V394.3H228.04V397.95H231.85Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M229.05 396.92H230.82V395.32H229.05V396.92Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M231.84 401.59V397.94H228.03V401.59H231.84Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M229.05 400.57H230.82V398.97H229.05V400.57Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M236.69 397.95V394.3H234.69V397.95H236.69Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M236.69 401.59V397.94H234.69V401.59H236.69Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M286.57 399.53V395.88H277.91V399.53H286.57Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M286.58 403.18V399.53H277.92V403.18H286.58Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M283.8 399.54V395.89H279.99V399.54H283.8Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M281 398.51H282.77V396.91H281V398.51Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M283.8 403.18V399.53H279.99V403.18H283.8Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M281 402.16H282.77V400.56H281V402.16Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M286.58 406.83V403.18H277.92V406.83H286.58Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M283.79 406.83V403.18H279.98V406.83H283.79Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M281 405.81H282.77V404.21H281V405.81Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M286.57 411.97V408.32H277.91V411.97H286.57Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M286.58 415.61V411.96H277.92V415.61H286.58Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M283.8 411.97V408.32H279.99V411.97H283.8Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M281 410.94H282.77V409.34H281V410.94Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M283.8 415.61V411.96H279.99V415.61H283.8Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M281 414.59H282.77V412.99H281V414.59Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M286.58 419.26V415.61H277.92V419.26H286.58Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M283.8 419.26V415.61H279.99V419.26H283.8Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M281 418.24H282.77V416.64H281V418.24Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M232.41 427.55C235.144 427.55 237.36 425.334 237.36 422.6C237.36 419.866 235.144 417.65 232.41 417.65C229.676 417.65 227.46 419.866 227.46 422.6C227.46 425.334 229.676 427.55 232.41 427.55Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M232.41 423.68C233.007 423.68 233.49 423.197 233.49 422.6C233.49 422.004 233.007 421.52 232.41 421.52C231.814 421.52 231.33 422.004 231.33 422.6C231.33 423.197 231.814 423.68 232.41 423.68Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M240.26 429.32H254.89"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M252.67 431.97V426.68H242.34V431.97H252.67Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M263.35 417.39H259.78V427.72H263.35V417.39Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M259.78 425.76H263.25"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M259.78 423.68H263.25"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M259.78 421.61H263.25"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M259.78 419.54H263.25"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M291.01 472.74C291.01 484.86 271.67 470.65 271.67 485.34"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M228.93 466.47C223.7 466.47 222.88 469.34 222.88 472.74"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M284.96 466.47C290.19 466.47 291.01 469.34 291.01 472.74"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M228.93 456.08C223.7 456.08 222.88 458.95 222.88 462.35V472.74"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M222.88 472.74V451.93C222.88 448.53 223.7 445.66 228.93 445.66"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M228.93 435.21C223.7 435.21 222.88 438.08 222.88 441.48V472.74"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M284.96 456.08C290.19 456.08 291.01 458.95 291.01 462.35V472.74"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M291.01 472.74V451.93C291.01 448.53 290.19 445.66 284.96 445.66"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M284.96 435.21C290.19 435.21 291.01 438.08 291.01 441.48V472.74"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M222.88 472.74C222.88 484.86 242.22 470.65 242.22 485.34V601.3C242.22 606.82 246.7 611.3 252.22 611.3H281.89"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M271.67 485.33V571.29C271.67 576.81 276.15 581.29 281.67 581.29H311.34"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M311.33 581.3H459.3C464.82 581.3 469.3 576.82 469.3 571.3V399.82C469.3 394.3 464.82 389.82 459.3 389.82H440.73"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M509.15 481.3V601.3C509.15 606.82 504.67 611.3 499.15 611.3H269.54"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M738.76 481.3V601.3C738.76 606.82 734.28 611.3 728.76 611.3H499.15"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M968.37 481.3V601.3C968.37 606.82 963.89 611.3 958.37 611.3H728.76"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1197.98 481.3V601.3C1197.98 606.82 1193.5 611.3 1187.98 611.3H958.37"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M459.3 581.3H689.2C694.72 581.3 699.2 576.82 699.2 571.3V399.82C699.2 394.3 694.72 389.82 689.2 389.82H670.34"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M689.2 581.3H918.52C924.04 581.3 928.52 576.82 928.52 571.3V399.82C928.52 394.3 924.04 389.82 918.52 389.82H899.95"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M918.52 581.3H1148.13C1153.65 581.3 1158.13 576.82 1158.13 571.3V399.82C1158.13 394.3 1153.65 389.82 1148.13 389.82H1129.56"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M473.85 64.44V36.4"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M468.39 162.45H479.31V64.4401H468.39V162.45Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M257.7 64.44V36.4"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M252.24 162.45H263.16V64.4401H252.24V162.45Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M690 64.44V36.4"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M684.54 162.45H695.46V64.4401H684.54V162.45Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1122.3 64.44V36.4"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1116.84 162.45H1127.76V64.4401H1116.84V162.45Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M906.15 64.44V36.4"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M900.69 162.45H911.61V64.4401H900.69V162.45Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1014.09 150.63H1004.05V188.3H1014.09V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1020 150.63H998.14V188.3H1020V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1025.74 109.9V150.63H992.41V109.9H978.69V76.45H1039.46V109.9H1025.74Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1035.31 74.38H1030.47V111.97H1035.31V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M990.34 118.98V123.82H1027.81V118.98H990.34Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M990.34 141.79V146.63H1027.81V141.79H990.34Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M987.67 74.38H982.83V111.97H987.67V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1016.31 188.3H1001.83V200.89H1016.31V188.3Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1014.09 150.63H1004.05V188.3H1014.09V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1020 150.63H998.14V188.3H1020V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1025.74 109.9V150.63H992.41V109.9H978.69V76.45H1039.46V109.9H1025.74Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1035.31 74.38H1030.47V111.97H1035.31V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M990.34 118.98V123.82H1027.81V118.98H990.34Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M990.34 141.79V146.63H1027.81V141.79H990.34Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M987.67 74.38H982.83V111.97H987.67V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1016.31 188.3H1001.83V200.89H1016.31V188.3Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M784.59 150.63H774.55V188.3H784.59V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M790.51 150.63H768.65V188.3H790.51V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M796.24 109.9V150.63H762.91V109.9H749.19V76.45H809.96V109.9H796.24Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M805.81 74.38H800.97V111.97H805.81V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M760.84 118.98V123.82H798.31V118.98H760.84Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M760.84 141.79V146.63H798.31V141.79H760.84Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M758.17 74.38H753.33V111.97H758.17V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M786.81 188.3H772.33V200.89H786.81V188.3Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M784.59 150.63H774.55V188.3H784.59V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M790.51 150.63H768.65V188.3H790.51V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M796.24 109.9V150.63H762.91V109.9H749.19V76.45H809.96V109.9H796.24Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M805.81 74.38H800.97V111.97H805.81V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M760.84 118.98V123.82H798.31V118.98H760.84Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M760.84 141.79V146.63H798.31V141.79H760.84Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M758.17 74.38H753.33V111.97H758.17V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M786.81 188.3H772.33V200.89H786.81V188.3Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M555.09 150.63H545.05V188.3H555.09V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M561.01 150.63H539.15V188.3H561.01V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M566.74 109.9V150.63H533.41V109.9H519.69V76.45H580.46V109.9H566.74Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M576.31 74.38H571.47V111.97H576.31V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M531.34 118.98V123.82H568.81V118.98H531.34Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M531.34 141.79V146.63H568.81V141.79H531.34Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M528.67 74.38H523.83V111.97H528.67V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M557.32 188.3H542.84V200.89H557.32V188.3Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M555.09 150.63H545.05V188.3H555.09V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M561.01 150.63H539.15V188.3H561.01V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M566.74 109.9V150.63H533.41V109.9H519.69V76.45H580.46V109.9H566.74Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M576.31 74.38H571.47V111.97H576.31V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M531.34 118.98V123.82H568.81V118.98H531.34Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M531.34 141.79V146.63H568.81V141.79H531.34Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M528.67 74.38H523.83V111.97H528.67V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M557.32 188.3H542.84V200.89H557.32V188.3Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M325.59 150.63H315.55V188.3H325.59V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M331.51 150.63H309.65V188.3H331.51V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M337.24 109.9V150.63H303.91V109.9H290.19V76.45H350.96V109.9H337.24Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M346.81 74.38H341.97V111.97H346.81V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M301.84 118.98V123.82H339.31V118.98H301.84Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M301.84 141.79V146.63H339.31V141.79H301.84Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M299.18 74.38H294.34V111.97H299.18V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M327.82 188.3H313.34V200.89H327.82V188.3Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M325.59 150.63H315.55V188.3H325.59V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M331.51 150.63H309.65V188.3H331.51V150.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M337.24 109.9V150.63H303.91V109.9H290.19V76.45H350.96V109.9H337.24Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M346.81 74.38H341.97V111.97H346.81V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M301.84 118.98V123.82H339.31V118.98H301.84Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M301.84 141.79V146.63H339.31V141.79H301.84Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M299.18 74.38H294.34V111.97H299.18V74.38Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M327.82 188.3H313.34V200.89H327.82V188.3Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <defs>
          <filter
            id="filter0_d_868_432"
            x="382.2"
            y="446.17"
            width="51.5798"
            height="52.28"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_868_432"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_868_432"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_868_432"
            x="383.64"
            y="371.66"
            width="57.5901"
            height="51.83"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_868_432"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_868_432"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_d_868_432"
            x="611.81"
            y="446.17"
            width="51.5801"
            height="52.28"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_868_432"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_868_432"
              result="shape"
            />
          </filter>
          <filter
            id="filter3_d_868_432"
            x="613.25"
            y="371.66"
            width="57.5898"
            height="51.83"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_868_432"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_868_432"
              result="shape"
            />
          </filter>
          <filter
            id="filter4_d_868_432"
            x="841.42"
            y="446.17"
            width="51.5801"
            height="52.28"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_868_432"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_868_432"
              result="shape"
            />
          </filter>
          <filter
            id="filter5_d_868_432"
            x="842.86"
            y="371.66"
            width="57.5898"
            height="51.83"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_868_432"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_868_432"
              result="shape"
            />
          </filter>
          <filter
            id="filter6_d_868_432"
            x="1071.03"
            y="446.17"
            width="51.5798"
            height="52.28"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_868_432"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_868_432"
              result="shape"
            />
          </filter>
          <filter
            id="filter7_d_868_432"
            x="1072.47"
            y="371.66"
            width="57.5901"
            height="51.83"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_868_432"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_868_432"
              result="shape"
            />
          </filter>
          <filter
            id="filter8_d_868_432"
            x="213.95"
            y="380.5"
            width="84"
            height="106.8"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_868_432"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_868_432"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_868_432"
            x1="1288.68"
            y1="433.2"
            x2="1234.31"
            y2="433.2"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.15" stop-color="#F7FAFC" />
            <stop offset="1" stop-color="#F7FAFC" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_868_432"
            x1="720.52"
            y1="29.39"
            x2="720.52"
            y2="83.76"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.15" stop-color="#F7FAFC" />
            <stop offset="1" stop-color="#F7FAFC" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_868_432"
            x1="152.36"
            y1="433.22"
            x2="206.72"
            y2="433.22"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.15" stop-color="#F7FAFC" />
            <stop offset="1" stop-color="#F7FAFC" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </template>
  </Configuration>
</template>

<script>
export default {
  name: 'ConfigurationShowers',
  data: () => ({
    items: [
      {
        label: 'PWT Controller',
        value: 'controller',
        x: 248,
        y: 210,
        title: 'PWT Controllers',
        content:
          'The nerve center of our PWT systems that allows control over lavatories, water closets, showers, or combination fixtures.',
        link: '/commercial-bathroom-products/pwt/microplumb-controllers',
        linkText: 'View PWT Controllers'
      },
      {
        label: 'Solenoid',
        value: 'solenoid',
        x: 526,
        y: 166,
        title: 'Solenoids',
        content: 'Electronically control water run-times to lavatory and shower fixtures.',
        link: '/commercial-bathroom-products/water-technology/solenoids',
        linkText: 'View PWT Solenoids'
      }
    ]
  })
};
</script>
